<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="54" height="33" viewBox="0 0 54 33">
  <defs>
    <path id="kuntvlwypb" d="M0 0L21.363 0 21.363 20.484 0 20.484z"/>
    <path id="vcuclxr0kd" d="M0 0L21.363 0 21.363 20.484 0 20.484z"/>
    <path id="3r4ih2c0if" d="M0 0L21.363 0 21.363 20.484 0 20.484z"/>
    <linearGradient id="2ygg9n87ia" x1="0%" x2="100%" y1="68.673%" y2="31.327%">
      <stop offset="0%" stop-color="#0168B4"/>
      <stop offset="18.838%" stop-color="#0168B4"/>
      <stop offset="50.596%" stop-color="#B8383C"/>
      <stop offset="100%" stop-color="#D90338"/>
    </linearGradient>
  </defs>
  <g fill="none" fill-rule="evenodd" transform="translate(54, 33) scale(-1, -1)">
    <g>
      <g>
        <path fill="url(#2ygg9n87ia)" d="M1 0h52c.552 0 1 .448 1 1v31c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1z" transform="translate(-5 -8) translate(5 8) matrix(-1 0 0 1 54 0)"/>
        <g transform="translate(-5 -8) translate(5 8) translate(15 5)">
          <g transform="rotate(-180 12 11.5)">
            <mask id="ylngp4b9rc" fill="#fff">
              <use xlink:href="#kuntvlwypb"/>
            </mask>
            <path fill="#FFF" d="M21.363 0L15.19 5.915c-1.047-.96-2.417-1.536-3.908-1.536-3.336 0-6.044 2.884-6.044 6.44 0 1.346.387 2.6 1.056 3.63L0 20.484V0h21.363z" mask="url(#ylngp4b9rc)"/>
          </g>
          <g transform="translate(1.5 1.5)">
            <mask id="1xx5u1y7ye" fill="#fff">
              <use xlink:href="#vcuclxr0kd"/>
            </mask>
            <path fill="#FFF" d="M21.363 0L15.19 5.915c-1.047-.96-2.417-1.536-3.908-1.536-3.336 0-6.044 2.884-6.044 6.44 0 1.346.387 2.6 1.056 3.63L0 20.484V0h21.363z" mask="url(#1xx5u1y7ye)"/>
          </g>
          <rect xmlns="http://www.w3.org/2000/svg" fill="#fff" x="9" y="11.6" width="7.5" height="1.32"/>
          <rect xmlns="http://www.w3.org/2000/svg" transform="rotate(90)" fill="#fff" x="8.5" y="-13.3" width="7.5" height="1.32"/>
        </g>
      </g>
    </g>
  </g>
</svg>
